<template>
  <v-app id="inspire">
    <v-navigation-drawer
        v-if="!loading.data"
        v-model="drawer"
        app
        expand-on-hover
        mini-variant>
        <v-list
            dense>
            <v-list-group v-for="(navGroup, index) in navGroups.filter(each => each.authorization == true)" :key="index">
                <template v-slot:activator>
                    <v-list-item-icon>
                        <v-icon>{{ navGroup.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ navGroup.text }}</v-list-item-title>
                </template>
                <v-list-item link 
                    v-for="(navItem, navItemIndex) in navGroup.navItems.filter(each => each.authorization == true)" 
                    :key="navItemIndex" 
                    :to="navItem.to"
                    dense>
                    <v-list-item-icon>
                        <v-icon>{{ navItem.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ navItem.text }}</v-list-item-title>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
    <v-app-bar
        v-if="!loading.data"
        app
        dense
        flat
        elevation="1"
        color="white">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>Administration</v-toolbar-title>
        <v-spacer></v-spacer>
        <ToolbarMenuRight/>
    </v-app-bar>
    <v-main >
      <v-container>
        <v-overlay :value="loading.data" opacity="0" z-index="4">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary">
            </v-progress-circular>
        </v-overlay>
        <router-view></router-view>
      </v-container>
    </v-main>
    <RetryDialog
        ref="retryDialog"
        @submit="onRetryDialogSubmit"/>
    <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ToolbarMenuRight from '@/components/common/ToolbarMenuRight';
import RetryDialog from '@/components/common/RetryDialog';
    export default {
        components: {
            RetryDialog,
            ToolbarMenuRight,
        },
        props: {
        source: String,
        },
        data: () => ({
        drawer: null,
        darkMode: false,
        module: 'administration',
        loading: {
            data: false
        }
        }),
        computed: {
            ...mapGetters({
                snackbar: "ui/snackbar/snackbar"
            }),
            ...mapState('authentication', ["authorizations"]),
            navGroups() {
                return [
                    {
                        text: this.$t('Administrations'),
                        icon: "mdi-view-dashboard-outline",
                        authorization: this.authorizations ? this.authorizations.users.read || this.authorizations.roles.read : false,
                        navItems: [
                            {
                                text:this.$t('users_title'),
                                icon: "mdi-account-group",
                                to: "/administration/users",
                                authorization: this.authorizations.users ? this.authorizations.users.read : false,
                            },
                            {
                                text: this.$t('roles_and_permission'),
                                icon: 'mdi-key-chain',
                                to: '/administration/roles',
                                authorization: this.authorizations.roles ? this.authorizations.roles.read : false,
                            }
                        ]
                    },
                    {
                        text: 'Stock Journal',
                        icon: "mdi-semantic-web",
                        authorization: true,
                        navItems: [
                            {
                                text: 'Roles',
                                icon: 'mdi-key-chain',
                                to: '/administration/stock-journal-roles',
                                authorization: true,
                            }
                        ]
                    }
                ]
            }  
        },
        methods: {
            ...mapActions({
                hideSnackbar: "ui/snackbar/hide"
            }),
            ...mapActions('authentication', ['fetchAuthorizations']),
            async createdDataFetch(){
                try {
                    this.loading.data = true;
                    await this.fetchAuthorizations(this.module);
                        this.loading.data = false;
                    
                } catch(error) {
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.retryDialog.open({target:"createdDataFetch",message});
                }
            },
            onRetryDialogSubmit(params){
                if(params.target == "createdDataFetch") {
                    if(params.retry) this.createdDataFetch();
                    else this.close()
                }
            },
        },
        created(){
            this.createdDataFetch();
        }
    }
</script>